import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useContent } from "../contexts/ContentContext";
import { AlertTriangle, ShieldCheck, ShieldX } from "lucide-react";

export default function KycBanner() {
  const { user } = useAuth();
  const { t } = useContent();
  const location = useLocation();
  if (!user) return null;
  if (location.pathname.startsWith("/register")) return null;
  if (location.pathname.startsWith("/admin")) return null;

  const status = user.kyc_status;
  if (!status || status === "approved") return null;

  let bg, Icon, title, msg;
  if (status === "submitted") {
    bg = "bg-[hsl(var(--secondary))]";
    Icon = ShieldCheck;
    title = t("kyc.banner_submitted_title", "Vérification d'identité en cours");
    msg = t("kyc.banner_submitted_msg", "Notre équipe valide votre pièce d'identité. Vous pourrez solliciter un artiste dès l'approbation.");
  } else if (status === "rejected") {
    bg = "bg-[hsl(var(--primary))] text-white";
    Icon = ShieldX;
    title = t("kyc.banner_rejected_title", "Vérification refusée");
    msg = user.kyc_reject_reason || t("kyc.banner_rejected_msg", "Veuillez recommencer la vérification d'identité.");
  } else {
    bg = "bg-foreground text-background";
    Icon = AlertTriangle;
    title = "Vérifiez votre identité";
    msg = "Pour solliciter un artiste, vous devez d'abord vérifier votre identité.";
  }

  return (
    <div data-testid={`kyc-banner-${status || "pending"}`} className={`${bg} border-b border-border`}>
      <div className="container-mc py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <div className="flex items-center gap-2 flex-1">
          <Icon className="w-4 h-4 shrink-0" />
          <p className="text-sm">
            <strong className="font-display">{title}.</strong> <span className="opacity-80">{msg}</span>
          </p>
        </div>
        {(status === "rejected" || status === "pending") && (
          <Link data-testid="kyc-banner-cta" to="/register" className="text-xs font-bold underline whitespace-nowrap">Refaire la vérification →</Link>
        )}
      </div>
    </div>
  );
}
